import React, {useEffect, useState} from "react";
import ReactAvatar from "react-avatar"
import axios from "axios";
import gravatar from "gravatar";
import {Avatar} from "antd";

const CustomAvatar = ({size, name, email}) => {
  const [avatar, setAvatar] = useState()

  useEffect(() => {
    let avatarUrl = gravatar.url(email, {
      protocol: 'https',
      size: 200,
      default: 404
    })

    axios({
      url: avatarUrl,
      method: 'GET',
    }).then((res) => {
      setAvatar(avatarUrl)
    }).catch((err) => {
      setAvatar(null)
    });

  }, [email])

  return (
    <>
      {
        avatar ? <Avatar
            size={size}
            className="rounded-circle"
            src={avatar}
          /> : <ReactAvatar
            name={name}
            size={size}
            className="rounded-circle"
          />
      }
    </>
  )
}

export default CustomAvatar